import React from "react";
import styled from "styled-components";
import PrimaryHeading from "../PrimaryHeading";
import Divider from "../Divider";

const SplitImageTop = ({ img, heading, subheading, numberLabel }) => {
  //Padding is calculated based on bg aspect ratio. Subtracts a bit to account for rounding

  const Main = styled.div`
    padding-top: ${Math.ceil(img.resolutions.height / 1920 * 100)}%;
    width: 100%;
    background-image: url("${img.resolutions.src}");
    position: relative;
    max-width: 100%;
    background-position: center top;
    background-size: cover;
    text-align: center;
    box-shadow: inset 0 10px 2px -4px rgba(0, 0, 0, 0.4);

    @media (max-width: 1029px) {
      background-position: inherit;
      background-position: center bottom;
    }
    @media (max-width: 768px) {
      background-size: 230%;
      padding-top: 64%;
    }
  `;

  const Heading = styled(PrimaryHeading)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 8vw;

    @media (max-width: 768px) {
      padding-top: 10vw;
    }
  `;

  return (
    <Main>
      <Heading
        heading={heading}
        subheading={subheading}
        img={numberLabel}
        color="white"
      />
    </Main>
  );
};

export const splitImg = graphql`
  fragment SplitImg on ImageSharp {
    resolutions(width: 1920, toFormat: JPG) {
      src,
      height
    }
  }
`;

export default SplitImageTop;



// WEBPACK FOOTER //
// ./src/components/SplitImageTop/index.js